import { useCallback, useRef } from "react";
import { useProjectUIStore } from "stores/projectStore";
import type { Node } from "interfaces/schemas";
import * as identify from "interfaces/utils/identifyNodeTypes";

export const useInitOpenMap = () => {
  const setOpenMapRef = useProjectUIStore((state) => state.setOpenMapRef);
  const openMapRef = useRef<Record<string, boolean>>({});

  const initOpenMap = useCallback(
    (nodes: Node[]) => {
      const openMap: Record<string, boolean> = {};
      calculateOpenMap(nodes, openMap);
      openMapRef.current = openMap;
      setOpenMapRef(openMapRef);
    },
    [setOpenMapRef],
  );

  return initOpenMap;
};

const calculateOpenMap = (treeNodes: Node[], map: Record<string, boolean>) => {
  treeNodes.forEach((node: Node) => {
    if (identify.isWizard(node) && !identify.isAnyProduct(node)) {
      if (!(node.id in map)) {
        map[node.id] = false;
      }
    }
  });
};
